import { Component, createElement,createRef, h } from 'preact';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { faCaretUp, faCircleNotch } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { createPortal } from 'preact/compat';
import adminAjaxApi from '../api/api';
import setBranch from '../api/setBranch';

export default class BranchModal extends Component {

	state = {
		selectedStore: null,
		regions: [],
		loading: true
	};

	modalRef = createRef();

	changeCallback;

	constructor(props) {
		super();
		this.state = {
			selectedStore: props.selectedStore,
			regions: window.tccdata.regions
		};

		this.changeCallback = props.onChanged;
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleClickOutside.bind(this), false);
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleClickOutside.bind(this), false);
	}

	toggle() {
		this.setState({
			open: !this.state.open
		})
	}

	/**
	 * Alert if clicked on outside of element
	 */
	handleClickOutside(event) {
		if (this.state.open && this.modalRef && !this.modalRef.current.contains(event.target)) {
			this.toggle();
		}
		return;
	}

	select(branch) {
		// if(
		// 	this.state.loading ||
		// 	window.tccdata.selected_store_id && window.tccdata.stores[window.tccdata.selected_store_id].branchId === branch.branchId
		// ) {
		// 	return;
		// }

		this.setState({
			loading: true,
			branchLoading: branch.branchId
		});

		adminAjaxApi(setBranch(branch.branchId),(resp) => {
			window.tccdata.regions = resp.data.regions;
			window.tccdata.selected_store_id = resp.data.selected_store.branchId;
			this.forceUpdate();
			this.changeCallback ? this.changeCallback() : null;

			// this is bad and should probably use a global state handler instead but whatever
			const event = new Event('branchModified');
			window.dispatchEvent(event);
			this.setState({
				loading: false,
				branchLoading: null
			});
			jQuery( document.body ).trigger( 'update_checkout' );
			jQuery( document.body ).trigger( 'wc_fragment_refresh' );

			// Zenoti integration
			function setCookie(cname, cvalue, exdays) {
				const d = new Date();
				d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
				let expires = "expires=" + d.toUTCString();
				document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
			}
			setCookie("location", resp.data.location, 30);
			setCookie("location_id", resp.data.location_id, 30);
			const customEvent = new CustomEvent("locationchange", {
				detail: {
					name: resp.data.location,
					id: resp.data.location_id,
				},
			});
			document.dispatchEvent(customEvent);
			// End Zenoti integration

			this.toggle();
		});
	}

	_toggleRegion(region) {
		region.active = !region.active;
		this.forceUpdate()
	}

	render(props, state) {
		return (
			<div>
				{createPortal(
					<div class={`gumnut-modal ${state.open ? ' active' : ''}`} style={{zIndex: 10000}}>
						<div class={'modal-content'} ref={this.modalRef}>
							<div class={'modal-header'}>
								<h3>Select Your Preferred Store</h3>
								<span class={'close'} onClick={e => this.toggle()}>
									<FontAwesomeIcon icon={faTimes}/>
								</span>
							</div>
							<div class={'modal-body'}>
								<ul class={'accordion-region'}>
									{
										window.tccdata.regions.map((region) => {
											return (
												<li>
													<div class={'accordion-region-selector' + (region.active ? ' active' : '')}>
														<a class={'region-title'} onClick={e => this._toggleRegion(region)}>
															{ region.title }
															<FontAwesomeIcon icon={faCaretUp}/>
														</a>
														<ul class={'accordion-branch'}>
															{
																region.branches.map((branch) => {
																	return (
																		<li class={'accordion-branch-selector'  + (branch.active ? ' active' : '')} onClick={e => this.select(branch)}>
																			<div class={'branch-content'}>
																				<span class={'branch-name'}>
																					{branch.branchName}
																				</span>
																				<span class={'branch-address'}>
																					{branch.address}
																				</span>

																			</div>
																			<div class={'btn-branch-select'}>
																				{(state.loading && state.branchLoading === branch.branchId) && <FontAwesomeIcon icon={faCircleNotch} spin/>}
																				{ state.branchLoading !== branch.branchId ? (branch.active ? 'Selected' : 'Select') : '' }
																			</div>
																		</li>
																	)
																})
															}
														</ul>
													</div>
												</li>
											)
										})
									}
								</ul>
							</div>
						</div>
					</div>
					, document.getElementById('branch-modal'))}
			</div>
		)

	}

}
